var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIconTransactionSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79961 11.9999H15.1996M13.0663 15.1999H15.1996M8.79961 8.79987H10.9329M17.3329 19.4665H6.66628C6.07717 19.4665 5.59961 18.989 5.59961 18.3999V5.59987C5.59961 5.01077 6.07717 4.5332 6.66628 4.5332H15.1996L18.3996 7.7332V18.3999C18.3996 18.989 17.922 19.4665 17.3329 19.4665Z",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconTransactionSecond);
export default __webpack_public_path__ + "static/media/ProfileIconTransactionSecond.3d30943b5639be089aa09b0d01fa084b.svg";
export { ForwardRef as ReactComponent };